/***************************************************************************/
"use client";
/***************************************************************************/

import React from "react";
import { TConnectionContext } from "./types";

/**
 * Context to store connection-related configurations, including the base URL,
 * request headers, and lifecycle hooks for fetch operations.
 */
const ConnectionContext = React.createContext<TConnectionContext>({
  /** Base URL for API requests. */
  rootUrl: "",
  /** Optional connection configuration. */
  config: undefined,
  /** Optional headers to be included in requests. */
  headers: undefined,
  /** Hook executed before a fetch request is initiated. */
  onBefore: () => undefined,
  /** Hook executed after a fetch request is completed. */
  onAfter: () => undefined,
});

export default ConnectionContext;
